module.exports = __webpack_public_path__ + "img/event-5.853e3267.png";